var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Endpoints, findScreenByUri, isScreen, Metric, ShowtimeProvider, Log, } from '@amzn/showtime';
import { StackActions } from '@react-navigation/native';
import React from 'react';
import { isUriAllowed, pushExternalUri, WebAppNavigation } from './navigation';
import TENANT_ID from './TenantId';
const TAG = 'ShowtimeWebApp';
export const logger = Log(TENANT_ID);
const noOp = (fn) => {
    const logMessage = `'${fn}' is not implemented in AtoZMobileWeb`;
    logger.error(logMessage);
    if (__DEV__) {
        // eslint-disable-next-line no-console
        console.error(`${logMessage}
        Please refer to our Evergreen documentation for more info:
        https://evergreen.corp.amazon.com/atoz-developer-program/develop/react_native_development/converting_to_web/#differences-from-native`);
    }
    Metric(`NoOpError.${fn}`, TENANT_ID).put();
};
const config = {
    atozApiGatewayUrl: Endpoints.ATOZ_API_GATEWAY,
    atozBaseUrl: Endpoints.ATOZ,
    stage: __DEV__ ? 'dev' : 'prod',
};
export default function ShowtimeWebApp({ bundleVersion, navigationRef, placements, providableUrls, userContext, }) {
    const goBack = () => {
        const navigation = navigationRef.current;
        if (!navigation) {
            console.warn(`${TAG} Attempted to call goBack before navigation was initialized`);
            return;
        }
        if (navigation.canGoBack()) {
            navigation.goBack();
        }
    };
    const popToTop = () => __awaiter(this, void 0, void 0, function* () {
        const navigation = navigationRef.current;
        if (!navigation) {
            console.warn(`${TAG} Attempted to call popToTop before navigation was initialized`);
            return;
        }
        if (navigation.canGoBack()) {
            navigation.dispatch(StackActions.popToTop());
        }
    });
    const pushUri = (uri, options = { allowRepeatedNavigation: true }) => __awaiter(this, void 0, void 0, function* () {
        const { allowRepeatedNavigation } = options;
        const navigation = navigationRef.current;
        if (!navigation) {
            console.warn(`${TAG} Attempted to call pushUri before navigation was initialized`);
            return;
        }
        if (!isUriAllowed(uri)) {
            yield pushExternalUri({ uri, newTab: true });
            return;
        }
        const screen = findScreenByUri(placements, uri);
        if (screen && isScreen(screen)) {
            const screenPlacement = screen;
            if (screenPlacement.component) {
                if (allowRepeatedNavigation) {
                    navigation.dispatch(StackActions.push(screenPlacement.id));
                }
                else {
                    navigation.navigate(screenPlacement.id);
                }
                return;
            }
        }
        yield pushExternalUri({ uri, newTab: false });
    });
    const actions = {
        goBack,
        popToTop,
        pushUri,
        /*
         * The remaining methods are not implemented in AtoZMobileWeb
        */
        changeLanguage: () => {
            noOp('changeLanguage');
            return Promise.resolve();
        },
        endSpoofing: () => {
            noOp('endSpoofing');
        },
    };
    const appContext = {
        // atoz-oauth-token is provided by the browser cookie
        // x-atoz-client-id must be set by the tenant request
        authenticatedRequestHeaders: () => Promise.resolve({}),
        bundleVersion,
        get supportedLanguages() {
            noOp('supportedLanguages');
            return [];
        },
    };
    return (React.createElement(ShowtimeProvider, { actions: actions, appContext: appContext, config: config, providableUrls: providableUrls, userContext: userContext },
        React.createElement(WebAppNavigation, { navigationRef: navigationRef, placements: placements })));
}
//# sourceMappingURL=ShowtimeWebApp.js.map